import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';
import getScrollbarSize from '../utils/scrollbarSize';
import toggleClass from '../toggle-class';
import ModalDialog from './dom/ModalDialog';
import ModalHeader from './dom/ModalHeader';
import ModalBody from './dom/ModalBody';
import Backdrop from './dom/Backdrop'; // This keeps track of how many modals that are open so that the
// container class and container padding for the scrollbar is correctly set.

var numberOfModalsOpen = 0;
var keyCodes = {
  ESCAPE: 27,
  ENTER: 13
};

var shouldBindKeyboard = function shouldBindKeyboard(_ref) {
  var isOpen = _ref.isOpen,
      keyboard = _ref.keyboard;
  return keyboard === null ? isOpen : keyboard;
};

var getToggleProps = function getToggleProps(isOpen) {
  return {
    scrollbarSize: typeof document !== 'undefined' ? getScrollbarSize() : null,
    className: isOpen ? 'tg-modal-open' : ''
  };
};

var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (e, extra) {
      // Don't do anything while animating
      var animating = _this.state.animating;

      if (animating) {
        return;
      }

      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          isStatic = _this$props.isStatic,
          onCancel = _this$props.onCancel;

      if (isOpen && !isStatic && onCancel) {
        onCancel(e, extra);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearAnimating", function () {
      _this.setState({
        animating: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeys", function (e) {
      // Handle escape press
      if (e.which === keyCodes.ESCAPE) {
        _this.onCancel(e, true);
      } else if (e.which === keyCodes.ENTER) {
        // Don't do anything while animating
        var animating = _this.state.animating;

        if (!animating) {
          var onConfirm = _this.props.onConfirm;

          if (onConfirm) {
            e.preventDefault();
            onConfirm();
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderChild", function (child) {
      if (!child) {
        return child;
      }

      var onCancel = _this.props.onCancel;

      var _ref2 = child.props || {},
          addClose = _ref2.addClose,
          headerOnCancel = _ref2.headerOnCancel;

      if (child.type === ModalHeader && addClose && !headerOnCancel) {
        return React.cloneElement(child, _objectSpread({}, child.props, {
          onCancel: onCancel
        }));
      }

      return child;
    });

    _defineProperty(_assertThisInitialized(_this), "renderTransition", function (element) {
      var TransitionClass = _this.props.TransitionClass;
      return React.createElement(TransitionClass, _extends({
        key: element.key
      }, _this.getAnimatorProps()), React.cloneElement(element));
    });

    _this.state = {
      animating: false
    };
    _this.node = React.createRef(); // validate children props and warn if something is wrong

    React.Children.forEach(props.children, function (child) {
      if (child && child.type === ModalHeader) {
        if (child.props.addClose && !child.props.onCancel) {
          // eslint-disable-next-line no-console
          console.warn("".concat(ModalHeader.displayName, ": addClose is defined but onCancel is missing!"));
        }
      }
    });
    return _this;
  } // Add support for SSR - since `componentDidMount` is not called in SSR anymore
  //   In the future we can probably do something with Suspense here.


  _createClass(Modal, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      if (typeof document === 'undefined') {
        var isOpen = this.props.isOpen;
        this.onToggle(isOpen, getToggleProps(isOpen));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var isOpen = this.props.isOpen;
      this.onToggle(isOpen, getToggleProps(isOpen));

      if (typeof document !== 'undefined') {
        if (shouldBindKeyboard(this.props)) {
          this.bindKeyboard();
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var isOpen = this.props.isOpen;

      if (prevProps.isOpen !== isOpen) {
        this.setState({
          animating: true
        });
      }

      var animating = this.state.animating;

      if (!prevState.animating && animating) {
        this.onToggle(isOpen, getToggleProps(isOpen));
      }

      var wasBound = shouldBindKeyboard(prevProps);
      var shouldBind = shouldBindKeyboard(this.props);

      if (wasBound !== shouldBind) {
        if (shouldBind) {
          this.bindKeyboard();
        } else {
          this.unbindKeyboard();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var isOpen = this.props.isOpen;

      if (isOpen) {
        this.onToggle(false, getToggleProps(isOpen));
      }

      if (typeof document !== 'undefined') {
        this.unbindKeyboard();
      }
    }
  }, {
    key: "onToggle",
    value: function onToggle(state, props) {
      var onToggle = this.props.onToggle;

      if (onToggle) {
        onToggle(state, props);
      } // Add body class and padding to scrollbar.


      if (typeof document !== 'undefined') {
        var _document = document,
            body = _document.body; // Increment modal count when opening.

        if (state) {
          numberOfModalsOpen += 1;
        } // Add toggle body class and update body padding if there is only one modal open.


        if (numberOfModalsOpen === 1) {
          // Toggle open class.
          toggleClass(body, 'tg-modal-open', state);
          var bodyScrollLock = this.props.bodyScrollLock;

          if (state) {
            if (bodyScrollLock && this.node.current) {
              disableBodyScroll(this.node.current, {
                reserveScrollBarGap: true
              });
            }
          } else if (bodyScrollLock && this.node.current) {
            clearAllBodyScrollLocks();
          }
        } // Decrement modal count when closing.


        if (!state) {
          numberOfModalsOpen = Math.max(numberOfModalsOpen - 1, 0);
        }
      }
    }
  }, {
    key: "getAnimatorProps",
    value: function getAnimatorProps() {
      var _this$props2 = this.props,
          transitionName = _this$props2.transitionName,
          transitionDuration = _this$props2.transitionDuration;
      var animating = this.state.animating;
      return {
        classNames: transitionName,
        timeout: transitionDuration,
        onEntered: this.clearAnimating,
        onExited: this.clearAnimating,
        unmountOnExit: true,
        "in": animating
      };
    }
  }, {
    key: "getAnimatorGroupProps",
    value: function getAnimatorGroupProps() {
      var wrapperClassName = this.props.wrapperClassName;
      var animating = this.state.animating;
      return {
        component: 'div',
        className: "tg-modal-wrapper ".concat(wrapperClassName, " ").concat(animating ? 'tg-modal-animating' : '').trim()
      };
    }
  }, {
    key: "bindKeyboard",
    value: function bindKeyboard() {
      // Ensure we don't bind twice
      this.unbindKeyboard();

      if (typeof document !== 'undefined') {
        this._keyHandler = this.handleKeys;
        document.addEventListener('keyup', this._keyHandler, false);
      }
    }
  }, {
    key: "unbindKeyboard",
    value: function unbindKeyboard() {
      if (typeof document !== 'undefined') {
        if (this._keyHandler) {
          document.removeEventListener('keyup', this._keyHandler, false);
          this._keyHandler = null;
        }
      }
    }
  }, {
    key: "renderModalBody",
    value: function renderModalBody() {
      var _this$props3 = this.props,
          autoWrap = _this$props3.autoWrap,
          children = _this$props3.children;
      var nodes = React.Children.map(children, this.renderChild);

      if (autoWrap) {
        return React.createElement(ModalBody, null, nodes);
      }

      return nodes;
    }
  }, {
    key: "renderModalHeader",
    value: function renderModalHeader() {
      var _this$props4 = this.props,
          title = _this$props4.title,
          isStatic = _this$props4.isStatic;

      if (!title) {
        // No title: Return nothing
        return null;
      } else if (typeof title === 'string') {
        // Title is a string, return a ModalHeader
        return React.createElement(ModalHeader, {
          addClose: !isStatic,
          onCancel: this.onCancel
        }, title);
      } else {
        // Fall back to rendering title directly (events should be handled by parent)
        return title;
      }
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      var _this$props5 = this.props,
          isOpen = _this$props5.isOpen,
          isBasic = _this$props5.isBasic,
          isStatic = _this$props5.isStatic,
          dialogClassName = _this$props5.dialogClassName,
          className = _this$props5.className;

      if (!isOpen) {
        return [];
      }

      return [this.renderTransition(React.createElement(Backdrop, {
        isStatic: isStatic,
        onCancel: this.onCancel,
        key: "backdrop"
      })), this.renderTransition(React.createElement(ModalDialog, {
        key: "dialog",
        isBasic: isBasic,
        onCancel: this.onCancel,
        className: dialogClassName,
        modalClassName: className,
        nodeRef: this.node
      }, this.renderModalHeader(), this.renderModalBody()))];
    }
  }, {
    key: "render",
    value: function render() {
      var TransitionGroupClass = this.props.TransitionGroupClass;
      return React.createElement(TransitionGroupClass, this.getAnimatorGroupProps(), this.renderModal());
    }
  }]);

  return Modal;
}(Component);

Modal.displayName = 'Modal';
Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  children: PropTypes.node,
  isStatic: PropTypes.bool,
  isBasic: PropTypes.bool,
  autoWrap: PropTypes.bool,
  className: PropTypes.string,
  dialogClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  transitionName: PropTypes.string,
  transitionDuration: PropTypes.number,
  title: PropTypes.node,
  TransitionClass: PropTypes.func,
  TransitionGroupClass: PropTypes.func,
  style: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  // Enable/disable keyboard events.
  // When null, the default, it will behave as having same value as isOpen
  keyboard: PropTypes.bool,
  // Enable/disable body scroll locking
  bodyScrollLock: PropTypes.bool,
  // This is internally used
  onToggle: PropTypes.func
};
Modal.defaultProps = {
  autoWrap: false,
  children: null,
  className: '',
  dialogClassName: 'tg-modal-dialog',
  wrapperClassName: '',
  isStatic: false,
  isBasic: false,
  bodyScrollLock: true,
  transitionName: 'tg-modal-fade',
  transitionDuration: 300,
  keyboard: null,
  onToggle: null,
  onConfirm: null,
  title: null,
  style: null,
  TransitionClass: CSSTransition,
  TransitionGroupClass: TransitionGroup
};
export default Modal;